import React from 'react';
import { searchPageStyles } from './SearchPage.styles';
import { Search } from 'lucide-react';
import SearchInputPrivacyNotice from './SearchInputPrivacyNotice';
import { SIDEBAR_DESKTOP_WIDTH_PX } from '../../utils/sidebarLayoutStore';

const TopSearchForm = React.forwardRef(function TopSearchForm(
  { searchInput, setSearchInput, handleTopSearch, headerScrolled },
  ref,
) {
  const padTop = headerScrolled
    ? `calc(4px + env(safe-area-inset-top, 0px))`
    : `calc(10px + env(safe-area-inset-top, 0px))`;
  const padBottom = headerScrolled ? '4px' : '6px';

  return (
    <form
      ref={ref}
      onSubmit={handleTopSearch}
      style={{
        ...searchPageStyles.topSearchForm,
        left: 'max(0px, calc(50vw - 240px))',
        right: 'max(0px, calc(50vw - 240px))',
        width: 'auto',
        padding: `${padTop} 12px ${padBottom} 12px`,
        transition:
          'left 0.25s ease, padding 0.2s cubic-bezier(.4,0,.2,1), box-shadow 0.2s cubic-bezier(.4,0,.2,1)',
      }}
      className="top-search-form"
    >
      <div style={searchPageStyles.searchInputContainer}>
        <input
          type="text"
          value={searchInput}
          onChange={e => setSearchInput(e.target.value)}
          placeholder="Search with parent or teacher guidance…"
          style={{
            ...searchPageStyles.searchInput,
            padding: headerScrolled ? '10px 16px' : '16px 24px',
            fontSize: headerScrolled ? 15 : 18,
          }}
          onFocus={(e) => e.target.style.borderColor = 'var(--color-primary)'}
          onBlur={(e) => e.target.style.borderColor = 'var(--color-border)'}
        />
        <button
          type="submit"
          style={{
            ...searchPageStyles.searchButton,
            padding: headerScrolled ? '10px 16px' : '16px 24px',
            minWidth: headerScrolled ? 60 : 100,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
          }}
          onMouseOver={(e) => e.target.style.background = 'var(--color-primary)'}
          onMouseOut={(e) => e.target.style.background = 'var(--color-primary)'}
          title="Search"
        >
          <Search size={20} />
          <span className="search-btn-text" style={{ marginLeft: 8 }}>Search</span>
        </button>
      </div>
      {/*
        alignItems:center on the form shrinks children to content width — the notice was centered
        as a narrow strip and its left edge could sit under the fixed sidebar. Stretch full width.
      */}
      <div
        style={{
          width: '100%',
          alignSelf: 'stretch',
          minWidth: 0,
          boxSizing: 'border-box',
        }}
      >
        <SearchInputPrivacyNotice variant="search" />
      </div>
      <style>
        {`
          @media (max-width: 480px) {
            .top-search-form .search-btn-text {
              display: none !important;
            }
          }
          /* When the rail is visible, never let this fixed bar sit under it (fixes clipped disclaimer). */
          @media (min-width: 769px) {
            .App[data-sidebar-rail="visible"] .top-search-form {
              left: ${SIDEBAR_DESKTOP_WIDTH_PX}px !important;
            }
          }
        `}
      </style>
    </form>
  );
});

export default TopSearchForm;
